import axios from 'axios'

const LaterPostingService = {
  async get (params = {}) {
    return axios.get('prd/purchase-order/request-later-postings', { params })
  },

  async show (id) {
    return axios.get(`prd/purchase-order/request-later-postings/${id}`)
  },

  async post (params = {}) {
    return axios.post('prd/purchase-order/request-later-postings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`prd/purchase-order/request-later-postings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`prd/purchase-order/request-later-postings/${data.id}`, { data })
  }
}

export default LaterPostingService
